<template>
  <div class="view setting-view">
    <HeaderBar />
    <router-link class="setting-item" to="/my/changePass">
      <div class="left">
        <!-- <img class="setting-img" src="../../assets/images/change_pw.png" /> -->
        <span>修改密码</span>
      </div>
      <div class="right">
        <img class="forward-img" src="../../assets/images/forward_small.png"/>
      </div>
    </router-link>
    <router-link class="setting-item" to="/agreement">
      <div class="left">
        <span>用户协议</span>
      </div>
      <div class="right">
        <img class="forward-img" src="../../assets/images/forward_small.png"/>
      </div>
    </router-link>
    <router-link class="setting-item" to="/my/privacyPolicy">
      <div class="left">        
        <span>隐私政策</span>
      </div>
      <div class="right">
        <img class="forward-img" src="../../assets/images/forward_small.png"/>
      </div>
    </router-link>
    <div class="setting-item" @click="clearBuffer">
      <div class="left">
        <!-- <img class="setting-img" src="../../assets/images/clear_cache.png" /> -->
        <span>清除缓存</span>
      </div>
      <div class="right">
        <img v-show="hasImg" class="forward-img" src="../../assets/images/forward_small.png"/>
        <span v-show="hasCache" class="forward-font">{{cacheSize}}</span>
      </div>
    </div>
    <div class="setting-item">
      <div class="left">
        <!-- <img class="setting-img" src="../../assets/images/push.png" /> -->
        <span>消息推送</span>
      </div>
      <div class="right">
        <van-switch
          active-color="#4CD964"
          inactive-color="#f44"
          :value="checked"
          @input="onInput"
        />
      </div>
    </div>
    <van-button class="logout-btn" type="danger" @click="onLogoutClick">退出登录</van-button>
  </div>
</template>
<script>
import { Button, Dialog, Switch } from 'vant';
import HeaderBar from '../../components/HeaderBar';
import apiUtil from '../../utils/apiUtil';
import apiConst from '../../consts/apiConst';
import { removeUser} from '../../utils/storageUtil';
export default {
  name: 'setting',
  components: {
    'van-button': Button,
    'van-switch': Switch,
    HeaderBar
  },
  data() {
    return {
      checked: true,
      hasImg:false,
      hasCache:true,
      cacheSize:''
    };
  },
  created(){
    window.HostApp.getSwitchStatus("pushCB")
    window.pushCB = this.pushCB;
  },
  mounted(){
    window.HostApp.getCacheSize('getBufferSize');
    window.getBufferSize = this.getBufferSize;

    // window.HostApp.getSwitchStatus("pushCB")
    // window.pushCB = this.pushCB;
  },
  methods: {
    onLogoutClick(){
      Dialog.confirm({
        title: '提示',
        message: '您确定要退出吗？'
      }).then(async () => {
        const res = await apiUtil.post(apiConst.submitLogout);
      if (res) {
        removeUser()
        this.$router.push('/login')
      }
        
      }).catch(() => {
        // on cancel
      });
    },
    clearBuffer(){
      Dialog.confirm({
        title: '提示',
        message: '您确定要清除缓存吗？'
      }).then(() => {
        window.HostApp.clearCache();
        this.cacheSize='0.00k';
      }).catch(() => {
        // on cancel
      });
    },
    onInput(checked){
      Dialog.confirm({
        title: '提醒',
        message: this.checked?'是否关闭消息推送？':'是否打开消息推送？'
        // message: this.checked?'是否打开消息推送？':'是否关闭消息推送？'
      }).then(() => {
        this.checked = checked;
        if(this.checked){
          window.HostApp.pushSwitch(1)
        }else{
          window.HostApp.pushSwitch(0)
        }
      }).catch(()=>{
      });
    },
    getBufferSize(result){
      this.cacheSize = result
    },
    pushCB(result){
      if(result=='yes'){
        this.checked=true;
      }else {
        this.checked=false;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.setting-view{
  padding-left: 35px;
  padding-right: 35px;
  background-color: #fff;
  .setting-item{
    height: 97px;
    display: flex;
    align-items center;
    justify-content space-between;
    border-bottom: 1px solid #E6E6E6
    color: #000;
    .left{
      display flex;
      align-items center
      font-size 32px
      color #333
      .setting-img{
        width: 40px;
        height: 40px;
        margin-right: 20px;
      }
    }
    .right {
      display flex;
      align-items center;
      .forward-img {
        width: 20px;
        height: 20px;
      }
      .forward-font{
        font-size:30px;
      }
    }
  }
  .logout-btn{
    width: 680px
    margin: 30px auto

  }
}
</style>
